<template>
  <div class="msg">
    <v-select
      id="event"
      v-model="event_id"
      :items="events"
      :label="getI18n('event')"
    ></v-select>
    <v-select
      id="campus_week"
      v-model="week_id"
      :items="weeks"
      :label="getI18n('campus.participate')"
    ></v-select>
    <v-select
      id="contact_type"
      v-model="contact_type_id"
      :items="contact_types"
      :label="getI18n('campus.participate')"
      disabled
    ></v-select>
  </div>
</template>

<script>
import store from "@/store";
import i18n from "@/i18n";
import { Api } from "@/core/api.js";
const api = new Api();

export default {
  props: { params: Object },
  components: {},
  data() {
    return {
      event_id: this.params.event_id,
      week_id: null,
      contact_type_id: null
    };
  },
  computed: {
    events: function() {
      var events = store.getters["events/getActives"]();
      var aEvents = [];
      for (var i in events) {
        var e = events[i];
        if (parseInt(e.is_campus) == 1) {
          aEvents.push({
            text: this.formatEventName(e.name, e.edition),
            value: e.id
          });
        }
      }
      return aEvents;
    },
    weeks: function() {
      var data = [];
      var self = this;
      var events = store.getters["events/getActives"]();
      if (this.event_id) {
        events.forEach(event => {
          if (event.id == self.event_id) {
            event.campus.forEach(week => {
              var sWeekName = week.name;
              if (event.type_id == 12) {
                sWeekName = sWeekName.split(".");
                sWeekName =
                  sWeekName[0] +
                  "." +
                  sWeekName[1] +
                  "." +
                  sWeekName[2] +
                  "_" +
                  sWeekName[3];
              }
              data.push({
                value: week.id,
                text:
                  self.getI18n(sWeekName) +
                  " " +
                  moment(week.start_date).format("DD/MM/YYYY") +
                  " - " +
                  moment(week.end_date).format("DD/MM/YYYY")
              });
            });
          }
        });
      }

      return data;
    },
    contact_types() {
      var contacts = store.getters["persons/getContactTypes"]();
      var data = [];
      var self = this;
      contacts.forEach(contact => {
        if (self.getI18n(contact.name) == "Participant") {
          self.contact_type_id = contact.id;
        }

        data.push({
          value: contact.id,
          text: self.getI18n(contact.name)
        });
      });
      return data;
    }
  },
  methods: {
    getI18n(label) {
      return i18n.t(label);
    },

    formatEventName(name, edition) {
      return name + "'" + edition.substring(2);
    },

    formatParam(param) {
      switch (param.type) {
        case "string":
          return param.value;
        case "role":
          return param.value.name;
        case "email":
          return param.value;
        case "phone":
          return "<v-icon size='18px'>phone</v-icon>" + param.value;
      }
    }
  },
  created() {
    var self = this;
  },
  watch: {
    event_id: {
      handler(v) {
        this.params.event_id = v;
      },
      deep: true
    },
    week_id: {
      handler(v) {
        this.params.week_id = v;
      },
      deep: true
    },
    contact_type_id: {
      handler(v) {
        this.params.contact_type_id = v;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  width: 100%;
  height: 150px;
  text-align: center;

  img {
    height: 100%;
    width: auto;
  }
}

.item {
  text-align: center;
  margin: 10px auto;
  width: fit-content;

  &.strong .value {
    font-weight: bold;
    font-size: 22px;
  }

  &.role {
    border-radius: 15px;
    padding: 5px 15px;
    font-weight: lighter;
    margin: 0 auto;

    &.r5 {
      background-color: $bg-role-5;
      color: $co-role-5;
    }

    & .value {
      font-size: 18px;
      text-transform: uppercase;
    }
  }

  &.club {
    position: relative;
  }
}
</style>
